module.exports = __webpack_public_path__ + "img/feature_lines.e8d6a444.svg";